import { accordion } from './accordion';
import { carousel } from './carousel';
import { flowchart } from './flowchart';
import { mainmenu } from './mainmenu';
import { Modal } from './modal';
import { quickscan } from './quickscan/quickscan';
import { tooltip, Tooltip } from './tooltip';
import { polyfill } from 'es6-promise';
import { questions } from './questions';
import { review } from './review';
import { cookieBar } from './cookie-bar/cookieBar';
import {funnelGuide} from "./funnelguide/funnelGuide";


polyfill();

window.addEventListener('DOMContentLoaded', (): void => {
    Modal.config({
        rootSelector: '.js-modal',
        overlaySelector: '.js-modal__overlay',
        contentSelector: '.js-modal__content',
        closeSelector: '.js-modal__close',
        titleSelector: '.js-modal__title',
        bodySelector: '.js-modal__body',
    });

    Tooltip.config({
        rootSelector: '.js-tooltip',
        titleSelector: '.js-tooltip__title',
        bodySelector: '.js-tooltip__body',
    });

    mainmenu();
    tooltip();
    quickscan();
    questions();
    review();
    accordion();
    carousel();
    flowchart();
    cookieBar();
    funnelGuide();

});
